import { requests } from '../../../api/agent'

export default {
    getSubthemes: (params) => requests.getWithParams('/ReSubthemesOgul/ListAllPaged', params),
    getSubthemeByName: (params) => requests.getWithParams('/ReSubthemesOgul/getByName', params),
    getByTheme: (params) => requests.getWithParams('/ReSubthemesOgul/listByTheme', params),
    getSubThemesCountByTheme: (params) => requests.getWithParams('/ReSubthemesOgul/getSubThemesCountByTheme', params),
    createSubthemeOgul: (params) => requests.post('/ReSubthemesOgul/CreateSubthemeOgul', params),
    deleteSubthemeOgul: (params) => requests.post('/ReSubthemesOgul/DeleteSubthemeOgul', params),
    updateSubthemeOgul: (params) => requests.post('/ReSubthemesOgul/UpdateSubthemeOgul', params),
    restoreSubthemeOgul: (params) => requests.post('/ReSubthemesOgul/RestoreSubthemeOgul', params),
    getReOrgReSubthemeOgulsList: () => requests.get(`/management/getReOrgReSubthemeOgulsList`),
    createReOrgReSubthemeOguls: (params) => requests.post(`/management/createReOrgReSubthemeOguls`, params),
    removeReOrgReSubthemeOguls: (params) => requests.post(`/management/removeReOrgReSubthemeOguls`, params)
}